import Controler from '../base/Controler';
import SimpleModal from './SimpleModal';
import VideoModal from './VideoModal';

class ModalControler extends Controler {
  constructor() {
    super();
    this.initSimpleModal();
    this.initSimpleModalWithoutHash();
    this.initVideoModal();
  }

  initSimpleModal(): SimpleModal[] {
    const modalsArr: SimpleModal[] = [];

    this.selectElements('.js-simple-modal').forEach(modal => {
      modalsArr.push(new SimpleModal(modal));
    });

    return modalsArr;
  }

  initSimpleModalWithoutHash(): SimpleModal[] {
    const modalsArr: SimpleModal[] = [];

    this.selectElements('.js-simple-modal-without-hash').forEach(modal => {
      modalsArr.push(new SimpleModal(modal, true, false));
    });

    return modalsArr;
  }

  initVideoModal(): VideoModal[] {
    const modalsArr: VideoModal[] = [];

    this.selectElements('.js-video-modal').forEach(modal => {
      modalsArr.push(new VideoModal(modal));
    });

    return modalsArr;
  }
}

export default ModalControler;
